import script from "./RepositionIdrosat.vue?vue&type=script&setup=true&lang=js"
export * from "./RepositionIdrosat.vue?vue&type=script&setup=true&lang=js"

import "./RepositionIdrosat.vue?vue&type=style&index=0&id=055896a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055896a1"]])

export default __exports__